import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useContext } from "react";
import MainContext from "../../context/mainContext";
import SlidesContent from "./SlidesContent/SlidesContent"
import VideoListBox from "./VideoListBox/VideoListBox"
import { isMobile } from 'react-device-detect';
import { Link } from "react-router-dom";
import HelpCenterIcon from '@mui/icons-material/HelpCenter';

export default function Tutorialumlang({ handleOpenSelectVideoBox, handleFullScreen, handlePlayingStatus }) {
    const [showTutorials, setShowTutorials] = React.useState(true);
    const { videoInfo, handleVideoInfo } = useContext(MainContext);
    const handleShowTutorials = (value) => {
        setShowTutorials(value)
    }

    return (<>
        <Box sx={{ display: showTutorials ? "block" : "none" }}>
            <Box>
                {/* <Box sx={{ justifyContent: "center", display: "flex", flexWrap: "wrap", mx: 10, mt: 10 }}> */}
                <VideoListBox handleFullScreen={handleFullScreen} handlePlayingStatus={handlePlayingStatus} />
            </Box>
            {/* <SlidesContent handleShowTutorials={handleShowTutorials} handleFullScreen={handleFullScreen} handlePlayingStatus={handlePlayingStatus} handleOpenSelectVideoBox={handleOpenSelectVideoBox} /> */}
        </Box>
    </>);
}

